export const hasSaenggibuResult = (snapshot) => {
  if (!snapshot || typeof snapshot !== 'object') return false;
  if (typeof snapshot.generationResult === 'string' && snapshot.generationResult.trim()) return true;
  if (Array.isArray(snapshot.versions) && snapshot.versions.some(item => (
    typeof item === 'string' && item.trim()
  ))) return true;
  return Array.isArray(snapshot.multiClassResults) && snapshot.multiClassResults.some(classResult => (
    Array.isArray(classResult?.versions)
      && classResult.versions.some(item => typeof item === 'string' && item.trim())
  ));
};

export const shouldClearSaenggibuResultForCategory = (resultContext, nextCategory) => (
  Boolean(resultContext?.category)
  && Boolean(nextCategory)
  && resultContext.category !== nextCategory
);

export const getSaenggibuCategoryChangeDialog = ({
  hasInput,
  hasResult,
  hasUnsavedResultEdits,
  isAuthenticated,
  savedRecordId,
}) => {
  const inputWillBeLost = Boolean(hasInput);
  const unsavedEditsWillBeLost = Boolean(hasUnsavedResultEdits);
  const hasSafelySavedResult = Boolean(
    hasResult
    && isAuthenticated
    && savedRecordId
  );
  const unsavedResultWillBeLost = Boolean(hasResult && !hasSafelySavedResult);

  if (!inputWillBeLost && !hasResult && !unsavedEditsWillBeLost) {
    return null;
  }

  let description = '';
  if (hasSafelySavedResult) {
    if (inputWillBeLost && unsavedEditsWillBeLost) {
      description = "현재 입력 내용과 저장하지 않은 수정은 초기화돼요. 마지막으로 저장된 결과는 '내 생기부 기록'에서 다시 볼 수 있어요.";
    } else if (inputWillBeLost) {
      description = "현재 입력 내용은 초기화돼요. 생성 결과는 '내 생기부 기록'에서 다시 볼 수 있어요.";
    } else if (unsavedEditsWillBeLost) {
      description = "저장하지 않은 수정은 초기화돼요. 마지막으로 저장된 결과는 '내 생기부 기록'에서 다시 볼 수 있어요.";
    } else {
      description = "지금 화면의 결과는 초기화돼요. 생성 결과는 '내 생기부 기록'에서 다시 볼 수 있어요.";
    }
  } else if (unsavedResultWillBeLost) {
    if (inputWillBeLost && unsavedEditsWillBeLost) {
      description = '입력한 내용과 저장하지 않은 수정, 아직 저장되지 않은 생성 결과가 사라져요.';
    } else if (inputWillBeLost) {
      description = '입력한 내용과 아직 저장되지 않은 생성 결과가 사라져요.';
    } else if (unsavedEditsWillBeLost) {
      description = '저장하지 않은 수정과 아직 저장되지 않은 생성 결과가 사라져요.';
    } else {
      description = '아직 저장되지 않은 생성 결과가 사라져요.';
    }
  } else if (inputWillBeLost && unsavedEditsWillBeLost) {
    description = '입력한 내용과 저장하지 않은 수정이 사라져요.';
  } else if (inputWillBeLost) {
    description = '입력한 내용이 사라져요.';
  } else {
    description = '저장하지 않은 수정이 사라져요.';
  }

  return {
    cancelLabel: '계속 작성',
    confirmLabel: '카테고리 변경',
    description,
    title: '카테고리를 변경할까요?',
  };
};

export const shouldConfirmSaenggibuCategoryChange = (state) => (
  Boolean(getSaenggibuCategoryChangeDialog(state))
);

export const hasSaenggibuFileUploadState = (fileUpload, uploadedFileContent) => (
  Boolean(
    fileUpload?.file
    || fileUpload?.files?.length > 0
    || fileUpload?.analysis
    || fileUpload?.pendingReview
    || uploadedFileContent
  )
);

export const summarizeSaenggibuResultFile = (file) => {
  const safeFile = file && typeof file === 'object' ? file : {};
  return {
    name: safeFile.name || safeFile.filename || '',
    size: Number(safeFile.size || safeFile.file_size) || 0,
    storagePath: safeFile.storage_path || safeFile.storagePath || '',
    contentLength: typeof safeFile.content === 'string' ? safeFile.content.length : 0,
  };
};
